export default __webpack_public_path__ + "static/media/611.c8711b98.png";